import { ReadonlyRequestCookies } from 'next/dist/server/web/spec-extension/adapters/request-cookies';
import { PortalNodeType, VirtualNodeBase, VirtualPortalNode } from '@nx-frontend/shared/types';
import { setCookie } from '@nx-frontend/shared/utils';

export const virtualPathsCookieName = 'virtualPaths';

export type VirtualNodeCookieItem = Pick<VirtualNodeBase, 'path' | 'type'>;

export const setVirtualPathsCookie = (nodes: VirtualPortalNode[]): void => {
  const paths: VirtualNodeCookieItem[] = Object.values(nodes).map(({ id, type, path }) => ({ id, type, path }));
  setCookie(virtualPathsCookieName, JSON.stringify(paths));
};

export const getSsrVirtualPaths = (cookies: ReadonlyRequestCookies): VirtualNodeCookieItem[] => {
  const cookieString = cookies.get(virtualPathsCookieName);
  if (cookieString?.value == null) {
    return [];
  }
  const values = JSON.parse(cookieString.value) as (VirtualNodeCookieItem | string)[];
  return values.map((value) => {
    return typeof value !== 'string'
      ? value
      : {
          id: '',
          path: value,
          type: PortalNodeType.PAGE,
        };
  });
};
